module.exports = __webpack_public_path__ + "img/xls.d0dd7b68.png";